import { Ppi } from "../../model";

export function getReccurentInvestsForOneYear(year:number,ppi:Ppi):number{
    let totalInvests = 0;
    if(ppi){
        const idx = ppi.investment_themes.findIndex(o=>o.name == "RECURRENT");
        if(idx!=-1){
            ppi.investment_themes[idx].themes.forEach(theme=>{
                theme.projects.forEach(project=>{
                    const amountIdx = project.years.findIndex(y=>y.year == year && y.amount != null && y.amount!=0);
                    if(amountIdx!=-1){
                        totalInvests += project.years[amountIdx].amount;
                    }
                })
            });
        }
    }
    return totalInvests;
}

export function computeAutofinancingNet(cafNette:number|null,invest:number|null):number{
    if(cafNette){
        if(invest){
            return cafNette - invest;
        }else{
            return cafNette
        }
    }else{
        return 0;
    }
}

export function computeTauxRemboursement(remboursementEmprunt:number|null,cafBrute:number|null):number{
    if(cafBrute && remboursementEmprunt && cafBrute!=0){
        return remboursementEmprunt/cafBrute;
    }else{
        return 0;
    }
}


// WEBPACK FOOTER //
// ./src/domain/sfp/dob-domain.ts